<template>
    <div>
        <div class="page-head">
            <a-icon @click="$router.go(-1)" type="left-square" theme="filled"/>
            <a-breadcrumb>
                <a-breadcrumb-item>首页</a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">客资管理</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;" @click="$router.go(-1)">线索列表</a></a-breadcrumb-item>
                <a-breadcrumb-item><a href="javascript:;">线索详情</a></a-breadcrumb-item>
            </a-breadcrumb>
        </div>


        <!-- 上半部分 -->
        <div class="detailContent">
            <div class="upperInfoContent">
                <div class="title">
                    <span class="name"><span v-if="cluedetail.username">{{cluedetail.username}}</span>
                    <span class="name" v-else>--</span></span>
                    <!-- <a-tag color="orange">{{cluedeatil.clue_type}}</a-tag> -->
                </div>
                <div class="back-btn">
                    <a-button style="margin-right:12px" @click="back" type="primary">返回</a-button>
                    <a-button-group>
                        <a-button @click="prev" icon="left" />
                        <a-button @click="next" icon="right" />
                    </a-button-group>
                </div>

                <div class="fieldContainer">
                    <div class="fieldItem">
                        <span>手机：</span>
                        <span v-if="cluedetail.telephone">
                            <a v-if="pwdtype==1" href="javascript:;">{{cluedetail.telephone}}</a>
                            <a v-if="pwdtype==2" href="javascript:;">{{cluedetail.telephone | topwd}}</a>
                            <a v-if="pwdtype==3" href="javascript:;">{{cluedetail.telephone | tomd5}}</a>
                        </span>
                        <span v-else>--</span>
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>地址：</span>
                        <span v-if="cluedetail.address">{{cluedetail.address}}</span>
                        <span v-else>--</span>   
                    </div>
                    <a-divider type="vertical" />
                    <div class="fieldItem">
                        <span>最近跟进时间：</span>
                        <span v-if="cluedetail.last_follow_time">{{cluedetail.updatetime | formatDate}}</span>
                        <span v-else>--</span>
                    </div>
                </div>

                <div class="btnListContainer" >
                    <a-button @click="tokehu" type="primary"><a-icon type="snippets" theme="filled"/>跟进线索</a-button>
                    <a-button @click="totel(usxsid)"><a-icon type="phone" theme="filled"/>拨打电话</a-button>
                </div>
            </div>
        </div>

        <!-- 下半部分 -->
        <div class="lowerInfoContent">
            <div class="basicinfo">
                
                <div class="information">
                    <div class="informationLeft">
                        <div class="title">
                            <img src="../../../static/flag.png" alt="">
                            <span>基本信息</span>
                        </div>
                        <a-descriptions bordered :column="2" :size="size">
                            <a-descriptions-item label="姓名">
                            {{cluedetail.username}}
                            </a-descriptions-item>

                            <a-descriptions-item label="性别">
                            <span v-if="cluedetail.sex==1">男</span>
                            <span v-if="cluedetail.sex==2">女</span>
                            <span v-else>--</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="电话">
                            <span v-if="pwdtype==1">{{cluedetail.telephone}}</span>
                            <span v-if="pwdtype==2">{{cluedetail.telephone | topwd}}</span>
                            <span v-if="pwdtype==3">{{cluedetail.telephone | tomd5}}</span>
                            </a-descriptions-item>
                            <a-descriptions-item label="线索来源">
                            {{cluedetail.title_sources}}
                            </a-descriptions-item>
                            <a-descriptions-item label="状态">
                            {{cluedetail.title_isvalid}}
                            </a-descriptions-item>
                            <a-descriptions-item label="备注" :span="3">
                            {{cluedetail.remarks}}
                            </a-descriptions-item>
                            <a-descriptions-item label="地址" :span="3">
                            {{cluedetail.province}}{{cluedetail.city}}{{cluedetail.area}}{{cluedetail.address}}
                            </a-descriptions-item>

                        </a-descriptions>
                    </div>
                    <div class="informationRight" >
                        <div class="title">
                            <img src="../../../static/flag.png" alt="">
                            <span>线索动态</span>
                        </div>
                        <a-timeline v-if="recordlist.length>0">
                            <div v-for="(item,i) in recordlist" :key="i">
                                <a-timeline-item >
                                    <span slot="dot" class="steps-index-TimeDot"></span>
                                    <div class="date-arrow">{{item.addtime | formatDate}}</div>
                                </a-timeline-item>
                                <a-timeline-item>
                                    <div class="description">
                                        <div class="dataContainer">
                                            <div v-if="item.fileurl" style="padding-top:20px">
                                                <audio class="detail-audio" controls="controls"  :src="item.fileurl"></audio> 
                                            </div>
                                            <span class="follow-title">{{item.title_isvalid}}</span>
                                            <span class="follow-date"><a-icon type="clock-circle"/>{{item.addtime | showdate}}</span>
                                            <div class="gjcontent" v-if="item.remarks_log">{{item.remarks_log}}</div> 
                                            <div class="gjcontent"  v-if="item.remarks_log==''&&item.fileurl==''">暂无备注</div>

                                            <div class="audio">
                                                <!-- <audio src=""></audio> -->
                                            </div>
                                            <!-- <div><p>来自线索：<a href="JavaScript:;">{{item.user_name}}</a></p></div> -->
                                            <div class="cz-user"><p>操作人：<span>{{item.username_kf}}</span></p></div>
                                        </div>
                                    </div>
                                </a-timeline-item>
                            </div>
                        </a-timeline>

                        <a-empty v-else description="暂无数据"/>
                    </div>
                </div>
                 
            </div>
        </div>

        <!-- 转客户 -->
         <a-modal
        title="线索跟进"
        :visible="editvisible"
        cancelText="取消"
        okText="确认"
        @ok="khhandleOk"
        @cancel="handleCancel"
        >
            <a-form class="dataform" :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
                <a-form-item label="线索操作">
                    <a-radio-group name="radioGroup" :default-value="1" @change="ontypeChange">
                        <a-radio :value="1">
                        转客户
                        </a-radio>
                        <a-radio :value="0">
                        状态跟进
                        </a-radio>
                        <a-radio :value="2">
                        无效
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <!-- <a-form-item label="购卡数量" v-if="numshow">
                    <a-input-number v-model="num" :precision="0" max="10" min="1" v-decorator="['购卡数量', { rules: [{ required: true, message: '请输入购卡数量' }] }]" />
                </a-form-item> -->

                <a-form-item label="跟进状态" v-if="numshow1">
                    <a-radio-group name="radioGroup"  @change="onstatusChange">
                        <a-radio :value="item.isvalid" v-for="item in statuslist" :key="item.isvalid">
                        {{item.title}}
                        </a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item label="回访时间" v-if="numshow1">
                    <a-date-picker :locale="locale" @change="onhfChange" placeholder="请选择回访时间"/>
                </a-form-item>
                

                
                <a-form-item label="姓名">
                    <a-input v-model="cluedetail.username" placeholder="请输入客户姓名"/>
                </a-form-item>
                <a-form-item label="电话">
                    <a-input v-model="cluedetail.telephone" placeholder="请输入客户电话"/>
                </a-form-item>
                <a-form-item label="地址">
                    <div style="dispaly:flex;justify-content: space-around;">
                        <!-- <a-cascader v-model="cluedetail.dz"  :field-names="{ label: 'name', value: 'name', children: 'area' }" @change="onaddressChange" :options="adddata" placeholder="请选择省、市、区"  /> -->
                        <v-distpicker :province="cluedetail.province" :city="cluedetail.city" :area="cluedetail.area" @selected="onaddressChange"></v-distpicker>
                    </div>
                   
                    <a-input v-model="cluedetail.address" placeholder="请输入详细地址"/>
                </a-form-item>
                <a-form-item label="性别">
                    <a-radio-group name="radioGroup" @change="cluedetail.sexSelectChange">
                        <a-radio :value="1">
                        男
                        </a-radio>
                        <a-radio :value="2">
                        女
                        </a-radio>
                    </a-radio-group>

                </a-form-item>

                <!-- <a-form-item label="出生日期">
                    <a-date-picker :locale="locale" @change="ondateChange" placeholder="请选择出生日期"/>
                </a-form-item> -->
                <a-form-item label="备注">
                    <a-textarea v-model="cluedetail.remarks" placeholder="备注" :rows="4" />
                </a-form-item>
            </a-form>
        </a-modal>

    </div>
</template>

<script>
import {formatDate} from '../../utils/formate.js'
import addresslist from '../../../static/address.json'
import md5 from 'js-md5'
export default {
    filters: {
      //年-月-日
        formatDate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd')
        },

        showdate (time) {
            time = time * 1000
            let date = new Date(time)
            return formatDate (date, 'yyyy-MM-dd hh:mm:ss')
        },
       topwd (value) {
            const start = value.slice(0, 3)
            const end = value.slice(-4)
            return `${start}****${end}`
        },
        tomd5(value){
            const text=md5(value)
            const text2=text.slice(0,10);
            return text2
        }
    },
    data(){
        const adddata = [];
        return{
            editvisible:false,
            numshow:true,
            numshow1:false,
            form: this.$form.createForm(this, { name: 'coordinated' }),
            gjrecord:[{date:'2021-06-07',add_time:'2021-06-07',user_name:'admin',content:'跟进内容'}],
            size:'middle',
            usxsid:"",
            isvalid:1,
            username:"",
            num:1,
            telephone:"",
            address:"",
            sex:"",
            birthday:"",
            remarks:"",

            cluedetail:"",//线索详情
            aid:"",
            statuslist:"",
            statusid:"",
            revisitdays:"",//回访时间
            recordlist:"",

            province:"",
            city:"",
            area:"",

            upnext:"",

            pwdtype:""
        }
    },
    created(){
        //修改的data值为JSON文件中想要的数据
        this.adddata = addresslist;
    },
    mounted(){
        this.usxsid=this.$route.query.id
        this.aid=this.$route.query.aid
        this.getdetail()
        this.getrecord()
        this.getstatus()
        this.pwdtype=localStorage.getItem('pwdtype')
    },
    methods:{
         // 上一条，下一条
        prev(){
            this.username=""
            this.telephone=""
            this.address=""
            this.sex=""
            this.remarks=""
            this.revisitdays=""
            this.province=""
            this.city=""
            this.area=""
            this.isvalid=""
           this.upnext=1
           this.getnextprev()
        },
        next(){
            this.username=""
            this.telephone=""
            this.address=""
            this.sex=""
            this.remarks=""
            this.revisitdays=""
            this.province=""
            this.city=""
            this.area=""
            this.isvalid=""
            this.upnext=2
            this.getnextprev()
        },

        getnextprev(){
             this.$axios.post('/api/user/userxsupnextpage',{
                aid:localStorage.getItem('aid'),
                usxsid:this.usxsid,
                upnext:this.upnext
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                    this.usxsid=res.data.data.usxsid
                    this.$axios.post('/api/user/userxsloglist',{
                        pagesize: 30,
                        usxsid:this.usxsid
                    },{
                        headers: {
                            "token":localStorage.getItem('token'),
                        }
                    }).then((res)=>{
                        if(res.data.code==200){
                            var data=res.data.data
                            this.recordlist=data
                        }else{
                            this.$message.warning(res.data.msg); 
                        }
                    
                    })
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })


           
        },
        totel(id){
            // console.log(id)
            // this.$axios.get('https://fxbkfluyin.13524.net/call_do.php?usxsid='+id,{},{
            //     headers: {
            //         "token":localStorage.getItem('token'),
            //     },
            // }).then((res)=>{
            //     if(res.data.code==100){
            //         this.$message.success(res.data.msg); 
            //     }else{
            //         this.$message.warning(res.data.msg); 
            //     }
            // })
            var phone=this.cluedetail.telephone
            sendMsg("changesim")

            this.$axios.post('/api/telephoneblack/verifytelephoneblack',{
                telephone:phone
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }  
            }).then((res)=>{
                if(res.data.code==200){
                    zhihu(phone)
                }else{
                    this.$message.error(res.data.msg);
                }
            })
            // zhihu(phone)
            this.tokehu()
        },
        // 省市区选择
        onaddressChange(value){
            this.province=value[0]
            this.city=value[1]
            this.area=value[2]
        },
        // 跟进记录
        getrecord(){
            this.$axios.post('/api/user/userxsloglist',{
                pagesize: 30,
                usxsid:this.usxsid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data
                    this.recordlist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },
        // 回访时间
        onhfChange(date, dateString) {
            // console.log(date, dateString);
            this.revisitdays=moment(dateString).unix()
        },
        // 状态跟进
        onstatusChange(e){
            this.statusid=e.target.value
        },
        getstatus(){
            this.$axios.post('/api/user/userisvalidlist',{
                pagesize: 30,
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    var data=res.data.data.data
                    this.statuslist=data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        },

        // 拨打电话
        call(id){

        },

        // 跟进线索
        handleCancel(){
            this.editvisible=false
        },
        tokehu(){
            // console.log("1111")
            this.editvisible=true
            console.log("1111="+ this.editvisible)
        },
        khhandleOk(){
            this.$axios.post('/api/user/edituserxs',{
                usxsid:this.usxsid,
                aid:this.aid,
                province:this.province,
                city:this.city,
                area:this.area,
                csid:1,
                isvalid:this.statusid,
                username:this.username,
                num:this.num,
                telephone:this.telephone,
                address:this.address,
                sex:this.sex,
                birthday:this.birthday,
                remarks:this.remarks,
                isuser:this.isvalid,
                revisitdays:this.revisitdays
                
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                   
                    this.editvisible=false
                    this.$message.success(res.data.msg); 
                }else{
                    this.$message.warning(res.data.msg); 
                }
            })
        },
        sexSelectChange(){
            this.sex=e.target.value
        },
        ondateChange(date, dateString) {
            console.log(date, dateString);
        },
        ontypeChange(e) {
            this.isvalid=e.target.value
            if( e.target.value==1){
                this.numshow=true
                this.numshow1=false
            }else if( e.target.value==0){
                this.numshow=false
                this.numshow1=true
            }
        },
        back(){
            this.$router.go(-1);//返回上一层
        },

        // 详情

        getdetail(){
             this.$axios.post('/api/user/userxspage',{
                usxsid:this.usxsid
            },{
                headers: {
                    "token":localStorage.getItem('token'),
                }
            }).then((res)=>{
                if(res.data.code==200){
                    this.cluedetail=res.data.data
                }else{
                    this.$message.warning(res.data.msg); 
                }
               
            })
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/resources/cluedetail.vue